// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Layout primitives
------------------------------------------------------------------- */

.shell {
  width: 100%;
  max-width: var(--maxw);
  margin-inline: auto;
  padding-inline: var(--gutter);
}
.shell--narrow { max-width: var(--maxw-narrow); }

.section {
  padding-block: var(--section-y);
  position: relative;
}
/* For blocks that sit right under another one and shouldn't double up. */
.section--tight { padding-block: clamp(2rem, 1.4rem + 2vw, 3.2rem); }

.section__head {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin-bottom: clamp(2.2rem, 1.5rem + 2vw, 3.6rem);
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  align-self: flex-start;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--accent);
}
.eyebrow::before {
  content: "";
  width: 22px;
  height: 2px;
  background: var(--accent);
}

.section__title {
  font-size: var(--step-3);
  max-width: 20ch;
}
.section__lede {
  color: var(--text-soft);
  max-width: 62ch;
  font-size: var(--step-1);
  line-height: 1.6;
}

.accent-text { color: var(--accent); }

.rule {
  height: 1px;
  border: 0;
  background: var(--line);
  margin: 0;
}

.grid {
  display: grid;
  gap: clamp(1rem, 0.6rem + 1.4vw, 1.6rem);
}
.grid > .reveal { display: grid; }
.grid > .reveal > * { height: 100%; }

.grid--2 { grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr)); }
.grid--3 { grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr)); }
.grid--4 { grid-template-columns: repeat(auto-fit, minmax(min(100%, 210px), 1fr)); }

.page {
  padding-top: var(--nav-h);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.page__body { flex: 1 1; }

.page-hero {
  padding-block: clamp(3.5rem, 2rem + 6vw, 6.5rem) clamp(1rem, 0.5rem + 2vw, 2rem);
  text-align: center;
}
.page-hero .eyebrow { align-self: center; }
.page-hero__title {
  font-size: var(--step-4);
  margin-block: 0.6rem 1rem;
}
.page-hero__lede {
  color: var(--text-soft);
  font-size: var(--step-1);
  max-width: 62ch;
  margin-inline: auto;
}

/* Reveal-on-scroll — driven by IntersectionObserver, transform/opacity only. */
.reveal {
  opacity: 0;
  transform: translate3d(0, 22px, 0);
  transition:
    opacity 0.7s var(--ease) var(--reveal-delay, 0ms),
    transform 0.7s var(--ease) var(--reveal-delay, 0ms);
  will-change: opacity, transform;
}
.reveal[data-visible="true"] {
  opacity: 1;
  transform: none;
  will-change: auto;
}
@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1; transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,iBAAiB,6BAA6B,EAAE;;AAEhD;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,yEAAyE;AACzE,kBAAkB,gDAAgD,EAAE;;AAEpE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,eAAe,oBAAoB,EAAE;;AAErC;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;AACA,kBAAkB,aAAa,EAAE;AACjC,sBAAsB,YAAY,EAAE;;AAEpC,WAAW,sEAAsE,EAAE;AACnF,WAAW,sEAAsE,EAAE;AACnF,WAAW,sEAAsE,EAAE;;AAEnF;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA,cAAc,SAAO,EAAE;;AAEvB;EACE,gFAAgF;EAChF,kBAAkB;AACpB;AACA,sBAAsB,kBAAkB,EAAE;AAC1C;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,UAAU;EACV,kCAAkC;EAClC;;uDAEqD;EACrD,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU,UAAU,EAAE,eAAe,EAAE;AACzC","sourcesContent":["/* ------------------------------------------------------------------\n   Layout primitives\n------------------------------------------------------------------- */\n\n.shell {\n  width: 100%;\n  max-width: var(--maxw);\n  margin-inline: auto;\n  padding-inline: var(--gutter);\n}\n.shell--narrow { max-width: var(--maxw-narrow); }\n\n.section {\n  padding-block: var(--section-y);\n  position: relative;\n}\n/* For blocks that sit right under another one and shouldn't double up. */\n.section--tight { padding-block: clamp(2rem, 1.4rem + 2vw, 3.2rem); }\n\n.section__head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  margin-bottom: clamp(2.2rem, 1.5rem + 2vw, 3.6rem);\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.7rem;\n  align-self: flex-start;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--accent);\n}\n.eyebrow::before {\n  content: \"\";\n  width: 22px;\n  height: 2px;\n  background: var(--accent);\n}\n\n.section__title {\n  font-size: var(--step-3);\n  max-width: 20ch;\n}\n.section__lede {\n  color: var(--text-soft);\n  max-width: 62ch;\n  font-size: var(--step-1);\n  line-height: 1.6;\n}\n\n.accent-text { color: var(--accent); }\n\n.rule {\n  height: 1px;\n  border: 0;\n  background: var(--line);\n  margin: 0;\n}\n\n.grid {\n  display: grid;\n  gap: clamp(1rem, 0.6rem + 1.4vw, 1.6rem);\n}\n.grid > .reveal { display: grid; }\n.grid > .reveal > * { height: 100%; }\n\n.grid--2 { grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr)); }\n.grid--3 { grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr)); }\n.grid--4 { grid-template-columns: repeat(auto-fit, minmax(min(100%, 210px), 1fr)); }\n\n.page {\n  padding-top: var(--nav-h);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.page__body { flex: 1; }\n\n.page-hero {\n  padding-block: clamp(3.5rem, 2rem + 6vw, 6.5rem) clamp(1rem, 0.5rem + 2vw, 2rem);\n  text-align: center;\n}\n.page-hero .eyebrow { align-self: center; }\n.page-hero__title {\n  font-size: var(--step-4);\n  margin-block: 0.6rem 1rem;\n}\n.page-hero__lede {\n  color: var(--text-soft);\n  font-size: var(--step-1);\n  max-width: 62ch;\n  margin-inline: auto;\n}\n\n/* Reveal-on-scroll — driven by IntersectionObserver, transform/opacity only. */\n.reveal {\n  opacity: 0;\n  transform: translate3d(0, 22px, 0);\n  transition:\n    opacity 0.7s var(--ease) var(--reveal-delay, 0ms),\n    transform 0.7s var(--ease) var(--reveal-delay, 0ms);\n  will-change: opacity, transform;\n}\n.reveal[data-visible=\"true\"] {\n  opacity: 1;\n  transform: none;\n  will-change: auto;\n}\n@media (prefers-reduced-motion: reduce) {\n  .reveal { opacity: 1; transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
